export enum RoutesSettings {
  Root = 'settings',
  Invoice = 'invoice',
  AdministrationConsent = 'administration-consent',
  DefaultImageAndDescription = 'resources-defaults',
}
